export const routes = [
  {
    path: '/',
    name: 'IndexPage',
    component: () => import('/app/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": "AuthLayout"
    }
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/app/src/pages/[...all].vue'),
    /* no children */
    meta: {
      "layout": 404
    }
  },
  {
    path: '/about',
    name: '/about',
    component: () => import('/app/src/pages/about.md'),
    /* no children */
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: '',
        name: '/auth/',
        component: () => import('/app/src/pages/auth/index.vue'),
        /* no children */
      },
      {
        path: 'login',
        name: 'AuthLoginPage',
        component: () => import('/app/src/pages/auth/login.vue'),
        /* no children */
        meta: {
          "layout": "AuthLayout"
        }
      },
      {
        path: 'recovery',
        name: 'AuthRecoveryPage',
        component: () => import('/app/src/pages/auth/recovery.vue'),
        /* no children */
        meta: {
          "layout": "AuthLayout"
        }
      },
      {
        path: 'signup',
        name: 'AuthSignUpPage',
        component: () => import('/app/src/pages/auth/signup.vue'),
        /* no children */
        meta: {
          "layout": "AuthLayout"
        }
      }
    ],
  },
  {
    path: '/customers',
    /* internal name: '/customers' */
    /* no component */
    children: [
      {
        path: ':uuid',
        name: 'CustomerItemPage',
        component: () => import('/app/src/pages/customers/[uuid].vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      }
    ],
  },
  {
    path: '/dashboard',
    name: 'DashboardPage',
    component: () => import('/app/src/pages/dashboard.vue'),
    /* no children */
    meta: {
      "layout": "AppLayout"
    }
  },
  {
    path: '/faq',
    name: 'FaqIndexPage',
    component: () => import('/app/src/pages/faq.vue'),
    /* no children */
    meta: {
      "layout": "AppLayout"
    }
  },
  {
    path: '/locations',
    /* internal name: '/locations' */
    /* no component */
    children: [
      {
        path: '',
        name: 'LocationsIndexPage',
        component: () => import('/app/src/pages/locations/index.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      }
    ],
  },
  {
    path: '/projects',
    name: '/projects',
    component: () => import('/app/src/pages/projects.vue'),
    /* no children */
  },
  {
    path: '/README',
    name: '/README',
    component: () => import('/app/src/pages/README.md'),
    /* no children */
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: '',
        name: 'SettingsIndexPage',
        component: () => import('/app/src/pages/settings/index.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      }
    ],
  },
  {
    path: '/terminals',
    /* internal name: '/terminals' */
    /* no component */
    children: [
      {
        path: '',
        name: 'TerminalsPage',
        component: () => import('/app/src/pages/terminals/index.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      },
      {
        path: ':uuid',
        name: 'TerminalItemPage',
        component: () => import('/app/src/pages/terminals/[uuid].vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      },
      {
        path: 'logs',
        name: 'TerminalLogsPage',
        component: () => import('/app/src/pages/terminals/logs.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      },
      {
        path: 'manufacturers',
        name: 'TerminalManufacturersPage',
        component: () => import('/app/src/pages/terminals/manufacturers.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      },
      {
        path: 'models',
        name: 'TerminalModelsPage',
        component: () => import('/app/src/pages/terminals/models.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      },
      {
        path: 'templates',
        name: 'TerminalTemplatesPage',
        component: () => import('/app/src/pages/terminals/templates.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      }
    ],
  },
  {
    path: '/transactions-ephemeral',
    /* internal name: '/transactions-ephemeral' */
    /* no component */
    children: [
      {
        path: '',
        name: 'TransactionsEphemeralIndexPage',
        component: () => import('/app/src/pages/transactions-ephemeral/index.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      },
      {
        path: ':uuid',
        name: 'TransactionEphemeralItemPage',
        component: () => import('/app/src/pages/transactions-ephemeral/[uuid].vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      }
    ],
  },
  {
    path: '/transactions-permenent',
    /* internal name: '/transactions-permenent' */
    /* no component */
    children: [
      {
        path: '',
        name: 'TransactionsPermanentIndexPage',
        component: () => import('/app/src/pages/transactions-permenent/index.vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      },
      {
        path: ':uuid',
        name: 'TransactionPermanentItemPage',
        component: () => import('/app/src/pages/transactions-permenent/[uuid].vue'),
        /* no children */
        meta: {
          "layout": "AppLayout"
        }
      }
    ],
  },
  {
    path: '/users',
    name: 'UsersIndexPage',
    component: () => import('/app/src/pages/users.vue'),
    /* no children */
    meta: {
      "layout": "AppLayout"
    }
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

